import { GoogleTagEvent } from '../helpers/api/api';
import { LitElement, css, html } from 'lit';

import { customElement } from 'lit/decorators';
import { getNewUiUrl } from '../helpers/auth-cookie';
import { getQueryStringParameters } from '../helpers/urls';

// Nothing is created here anymore: every legacy "make a map" link lands on the
// new templates hub. The event records where these visitors came from.
@customElement('template-onboard-page')
export class TemplateOnboardPage extends LitElement {
    amplitude_callsite: string = 'Template Onboard Page';

    firstUpdated() {
        const params = getQueryStringParameters();
        const target = `${getNewUiUrl()}/templates#maps`;
        let left = false;
        const go = () => {
            if (left) return;
            left = true;
            window.location.replace(target);
        };
        // gtag.js may still be loading; give the event a moment to send before leaving.
        window.setTimeout(go, 800);
        try {
            window.gtag('event', GoogleTagEvent.LEGACY_CREATE_REDIRECT, {
                callsite: this.amplitude_callsite,
                from: params.get('from') ?? 'link',
                referrer: document.referrer || 'direct',
                default_title: params.get('default_title') ?? '',
                template_topic_id: params.get('template_topic_id') ?? '',
                event_callback: go,
            });
        } catch {
            go();
        }
    }

    render() {
        return html`<div id="container">Taking you to templates…</div>`;
    }

    static get styles() {
        return css`
            #container {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0px;
                left: 0px;
                font-family: inherit;
                color: var(--main-text-color, #333);
            }
        `;
    }
}
